import Vue from 'vue'
import Router from 'vue-router'
import login from '@/login'
import certificate from '@/certificate/index'
import list from '@/certificate/list'
import topic from '@/topic/index'
import student from '@/student/index'
import statistics from '@/statistics/index'
import admin from '@/admin/index'
import user from '@/admin/user'
import account from '@/admin/account'
import open from '@/admin/open'
import config from '@/admin/config'
import organ from '@/admin/organ'
import course from '@/course/index'
import exam from '@/exam/index'
import type from '@/exam/type'
import examList from '@/exam/list'
import pack from '@/exam/pack'
import imitate from '@/exam/imitate'
import topicAdmin from '@/exam/topicAdmin'
import teacher from '@/exam/teacher'
import parent from '@/exam/parent'
import bank from '@/exam/bank'
import power from '@/exam/power'
import vipList from '@/vip/list'
import market from '@/market/list'
import exercises from '@/exam/exercises'
import title from '@/exam/title'
import exercisesTopic from '@/exam/exercisesTopic'
import score from '@/student/score'
import feedback from '@/market/feedback'


Vue.use(Router);

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode:'hash',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        title:'登录'
      }
    },
    {
      path: '/certificate',
      name: 'certificate',
      component: certificate,
      meta:{
        title:'证书列表'
      }
    },
    {
      path: '/list',
      name: 'list',
      component: list,
      meta:{
        title:'证书类型设置'
      }
    },
    {
      path: '/topic',
      name: 'topic',
      component: topic,
      meta:{
        title:'题目管理'
      }
    },
    {
      path: '/config',
      name: 'config',
      component: config,
      meta:{
        title:'题型配置'
      }
    },
    {
      path: '/student',
      name: 'student',
      component: student,
      meta:{
        title:'学员管理'
      }
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: statistics,
      meta:{
        title:'统计模块'
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: admin,
      meta:{
        title:'后台账号管理'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta:{
        title:'角色管理'
      }
    },
    {
      path: '/account',
      name: 'account',
      component: account,
      meta:{
        title:'账号信息'
      }
    },
    {
      path: '/open',
      name: 'open',
      component: open,
      meta:{
        title:'开通机构和账号'
      }
    },
    {
      path: '/organ',
      name: 'organ',
      component: organ,
      meta:{
        title:'机构-管理员'
      }
    },
    {
      path: '/course',
      name: 'course',
      component: course,
      meta:{
        title:'课程管理'
      }
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam,
      meta:{
        title:'考试类型管理'
      }
    },
    {
      path: '/type',
      name: 'type',
      component: type,
      meta:{
        title:'题型配置'
      }
    },
    {
      path: '/examList',
      name: 'examList',
      component: examList,
      meta:{
        title:'考试列表'
      }
    },
    {
      path: '/pack',
      name: 'pack',
      component: pack,
      meta:{
        title:'题库包'
      }
    },
    {
      path: '/imitate',
      name: 'imitate',
      component: imitate,
      meta:{
        title:'模拟卷'
      }
    },
    {
      path: '/topicAdmin',
      name: 'topicAdmin',
      component: topicAdmin,
      meta:{
        title:'题目管理'
      }
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: teacher,
      meta:{
        title:'老师管理'
      }
    },
    {
      path: '/parent',
      name: 'parent',
      component: parent,
      meta:{
        title:'家长管理'
      }
    },
    {
      path: '/bank',
      name: 'bank',
      component: bank,
      meta:{
        title:'查看题库'
      }
    },
    {
      path: '/power',
      name: 'power',
      component: power,
      meta:{
        title:'权限管理--模拟卷'
      }
    },
    {
      path: '/vipList',
      name: 'vipList',
      component: vipList,
      meta:{
        title:'会员管理'
      }
    },
    {
      path: '/market',
      name: 'market',
      component: market,
      meta:{
        title:'banner'
      }
    },
    {
      path: '/exercises',
      name: 'exercises',
      component: exercises,
      meta:{
        title:'练习题管理'
      }
    },
    {
      path: '/title',
      name: 'title',
      component: title,
      meta:{
        title:'大标题管理'
      }
    },
    {
      path: '/exercisesTopic',
      name: 'exercisesTopic',
      component: exercisesTopic,
      meta:{
        title:'题库列表'
      }
    },
    {
      path: '/score',
      name: 'score',
      component: score,
      meta:{
        title:'成绩管理'
      }
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: feedback,
      meta:{
        title:'意见反馈'
      }
    },
  ],
});

// const title = Vue.directive('title', {
//   inserted: function(el) {
//     document.title = el.getAttribute('title');
//   }
// })







// WEBPACK FOOTER //
// ./src/router/index.js